import { render, staticRenderFns } from "./UpdateSystemConfig.vue?vue&type=template&id=0689a3ec&scoped=true"
import script from "./UpdateSystemConfig.vue?vue&type=script&lang=js"
export * from "./UpdateSystemConfig.vue?vue&type=script&lang=js"
import style0 from "./UpdateSystemConfig.vue?vue&type=style&index=0&id=0689a3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0689a3ec",
  null
  
)

export default component.exports